var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.0357 19.2857C23.2893 19.2971 20.5773 18.6758 18.1093 17.471C18.1081 17.4704 18.1069 17.4698 18.1051 17.4692C17.626 17.2372 17.0492 17.4373 16.8166 17.9164L15.2502 21.157C11.2858 18.9687 8.01085 15.7178 5.79481 11.7715L9.0794 10.1828C9.0806 10.1822 9.08181 10.1816 9.08362 10.181C9.56154 9.94658 9.75922 9.36922 9.52538 8.89069C8.32183 6.42273 7.70228 3.71068 7.71433 0.964283C7.71433 0.431517 7.28282 0 6.75005 0H0.964352C0.431586 0 6.91936e-05 0.431517 6.91936e-05 0.964283C-0.00897096 4.87445 0.867924 8.7358 2.56506 12.2578C2.56506 12.2585 2.56567 12.2591 2.56567 12.2591L2.56506 12.2597C5.13849 17.5717 9.42775 21.8609 14.7403 24.4349L14.7409 24.4343C14.7415 24.4343 14.7422 24.4349 14.7422 24.4349C18.2648 26.1321 22.1255 27.009 26.0357 26.9999C26.5685 26.9999 27 26.5684 27 26.0356V20.2499C27 19.7172 26.5685 19.2857 26.0357 19.2857Z",
    fill: "#00539F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIcon);
export default __webpack_public_path__ + "static/media/phone_icon.c4924090.svg";
export { ForwardRef as ReactComponent };